export interface HeaderBreadcrumb {
  root: string;
  current: string;
  homeRoute?: string;
}

export function getHeaderBreadcrumb(pathname: string): HeaderBreadcrumb {
  if (
    pathname.startsWith('/sia/onboarding') ||
    pathname.startsWith('/sia/components/process-files') ||
    pathname.startsWith('/sia/components/onboard-inventory')
  ) {
    return {
      root: 'Workspace',
      current: 'Onboarding',
      homeRoute: 'sia/components',
    };
  }

  if (pathname === '/sia/components') {
    return {
      root: 'Workspace',
      current: 'Components',
      homeRoute: 'sia/components',
    };
  }

  if (pathname === '/sia/coveragekit') {
    return {
      root: 'Workspace',
      current: 'CoverageKit',
    };
  }

  if (pathname === '/sia/assistant') {
    return {
      root: 'Workspace',
      current: 'Assistant',
    };
  }

  if (pathname.includes('/code_analysis/')) {
    return { root: 'Workspace', current: 'Code Analysis' };
  }

  if (pathname.includes('/coverage_analysis/')) {
    return { root: 'Workspace', current: 'Coverage' };
  }

  if (pathname.includes('/manual-testing')) {
    return { root: 'Workspace', current: 'Manual Testing' };
  }

  // if (pathname.includes('/releases')) {
  //   return { root: 'Workspace', current: 'Releases' };
  // }

  if (pathname.startsWith('/profile')) {
    return { root: 'Workspace', current: 'Profile' };
  }

  return {
    root: 'Workspace',
    current: 'Components',
    homeRoute: 'sia/components',
  };
}
